import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/motion/SmoothScroll";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App">
      <SmoothScroll>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </SmoothScroll>
      <Toaster
        theme="light"
        position="top-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid #E2E8F0",
            color: "#0A1628",
          },
        }}
      />
    </div>
  );
}

export default App;
